import React from "react";

const SurveyTimeVariable = ({ campaign, surveyStatus = [] }) => {
  const getStatus = () => {
    const statusObj = surveyStatus.find(
      (item) => item.id === campaign?.statusId
    );
    return statusObj?.value?.toLowerCase() || "";
  };

  const status = getStatus();

  const formattedDateTime = (date) => {
    if (!date) return "--";

    const dateTime = new Date(date);

    return dateTime.toLocaleString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  };

  const dateTimeVariable1 = () => {
    if (["draft", "live"].includes(status)) {
      return (
        <>
          <h5 className="no-margin">Created:</h5>
          &nbsp;&nbsp;
          <h5 className="no-margin move-down">
            {formattedDateTime(campaign?.created_at || campaign?.startDate)}
          </h5>
        </>
      );
    }

    if (["finished", "stopped"].includes(status)) {
      return (
        <>
          <h5 className="no-margin">Started:</h5>
          &nbsp;&nbsp;
          <h5 className="no-margin move-down">
            {formattedDateTime(campaign?.startDate)}
          </h5>
        </>
      );
    }

    return null;
  };

  const dateTimeVariable2 = () => {
    if (status === "live") {
      return (
        <>
          <h5 className="no-margin">Started:</h5>
          &nbsp;&nbsp;
          <h5 className="no-margin move-down">
            {formattedDateTime(campaign?.startDate)}
          </h5>
        </>
      );
    }

    if (status === "draft") {
      return (
        <>
          <h5 className="no-margin">Modified:</h5>
          &nbsp;&nbsp;
          <h5 className="no-margin move-down">
            {formattedDateTime(campaign?.updated_at || campaign?.startDate)}
          </h5>
        </>
      );
    }

    if (status === "finished") {
      return (
        <>
          <h5 className="no-margin">Ended:</h5>
          &nbsp;&nbsp;
          <h5 className="no-margin move-down">
            {formattedDateTime(campaign?.endDate)}
          </h5>
        </>
      );
    }

    if (status === "stopped") {
      return (
        <>
          <h5 className="no-margin">Stopped:</h5>
          &nbsp;&nbsp;
          <h5 className="no-margin move-down">
            {formattedDateTime(campaign?.deactivatedAt || campaign?.startDate)}
          </h5>
        </>
      );
    }

    return null;
  };

  return (
    <div className="time-variables push-down">
      <div className="row spaced baseline">
        Start Date: {formattedDateTime(campaign?.startDate)}
      </div>

      <div className="row spaced baseline">
        End Date:{" "}
        {formattedDateTime(campaign?.endDate) === null
          ? "ongoing"
          : formattedDateTime(campaign?.endDate)}
      </div>
    </div>
  );
};

export default SurveyTimeVariable;
